import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
import { useSelector } from "react-redux";
const Qualification = (props) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.login);
  const language = useSelector((state)=> state.languages?.data)

  const [attributes] = useState(() => {
    const baseAttributes = [
      {
        type: "text",
        placeholder: "de",
        name: "de",
        validation: "",
        default: "",
        label: "de",
        required: true,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "text",
        placeholder: "en",
        name: "en",
        validation: "",
        default: "",
        label: "en",
        required: true,
        view: true,
        add: true,
        update: true,
      }
    ];

    language.length >0 && language?.filter((val)=> val?.id?.toLowerCase()!=="de" && val?.id?.toLowerCase()!=="en")?.map((item)=>{
      baseAttributes.push({
        type: "text",
        placeholder: item.id?.toLowerCase(),
        name: item.id?.toLowerCase(),
        validation: "",
        default: "",
        label: item.id?.toLowerCase(),
        required: false,
        view: true,
        add: true,
        update: true,
      })
    })
  
    // If the user's role is "super", add the "en" object to the array
    // if (user.data?.user?.role === "super") {
    //   baseAttributes.unshift({
    //     type: "text",
    //     placeholder: "en",
    //     name: "en",
    //     validation: "",
    //     default: "",
    //     label: "en",
    //     required: true,
    //     view: true,
    //     add: true,
    //     update: true,
    //   });
    // }
  
    return baseAttributes;
  });


  //to update the page title
  useEffect(() => {
    document.title = `${t("Qualification-Type")} - PersoBase`;
  }, [t]);
  // const [actions] = useState([{ element: "button", icon: "timings", type: "subList", id: "shift-timing", itemTitle: "title", title: "timings", attributes: timingAttributes, params: { api: `timing`, itemTitle: "title", shortName: "Timing", addPrivilege: true, delPrivilege: true, updatePrivilege: true, customClass: "medium" } }]);
  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container className="noshadow">
      <ListTable {...props} api={`qualification-type`} itemTitle={localStorage.getItem("_lang") ?? "de"} shortName={`qualificationType`} addPrivilege={true} delPrivilege={true} updatePrivilege={true} attributes={attributes}></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Qualification);
